// lib
import { createAction } from "@reduxjs/toolkit";

export const appGoesActive = createAction("system/app/active");
export const appGoesIdle = createAction("system/app/idle");
export const hydrateSlice = createAction("system/hydrate/slice");
export const hydrateSuccess = createAction("system/hydrate/success");
export const networkError = createAction("system/network/error");
export const discardNetworkError = createAction("system/network/error/discard");
